import { Button } from "../../buttons/Button";
import { footerActionBarStyles } from "../../Sheet/sheet.css";
import { saveButtonStyles } from "./filterFooter.css";
import { usePlosTranslations } from "../../../contexts/PlosTranslationsContext";

interface FilterFooterProps {
  isDisabled: boolean;
  handleSave: () => void;
  handleClose?: () => void;
}

const FilterFooter = ({
  isDisabled,
  handleSave,
  handleClose,
}: FilterFooterProps) => {
  const { filterSheet } = usePlosTranslations();
  const handleSaveAndClose = () => {
    handleSave();
    if (handleClose) {
      handleClose();
    }
  };

  return (
    <div className={footerActionBarStyles}>
      <Button
        onPress={handleSaveAndClose}
        isDisabled={isDisabled}
        aria-label={filterSheet.saveFilterChanges}
        // TODO: Remove saveButtonStyles and replace appropriately
        className={saveButtonStyles}
      >
        {filterSheet.saveChanges}
      </Button>
    </div>
  );
};

export default FilterFooter;
